import type { ReactNode } from 'react';
import { Logo } from '../ui/Logo';

type Props = {
  children: ReactNode;
  /** Optional polite status for screen readers during transitions */
  liveStatus?: string;
};

/**
 * Shared presentation for browser-only email confirm / password reset.
 * House Lights Down: grain stage + centered .cine-card (not .panel).
 */
export function AuthCallbackShell({ children, liveStatus }: Props) {
  return (
    <div className="grain flex min-h-screen items-center justify-center px-4 py-8 sm:px-6">
      <div className="w-full max-w-md space-y-7">
        <div className="animate-rise text-center">
          <Logo size="lg" linked={false} />
        </div>

        <div
          className="cine-card animate-rise delay-75 rounded-2xl p-6 sm:p-8"
          aria-live="polite"
          aria-atomic="true"
        >
          {liveStatus ? <span className="sr-only">{liveStatus}</span> : null}
          {children}
        </div>
      </div>
    </div>
  );
}

export function AuthCallbackProgress({ label }: { label: string }) {
  return (
    <div className="space-y-5 text-center">
      <div
        className="mx-auto h-1 w-40 max-w-full overflow-hidden rounded-full bg-secondary"
        role="progressbar"
        aria-label={label}
      >
        <div className="animate-progress h-full rounded-full bg-primary" />
      </div>
      <p className="text-sm text-muted-foreground">{label}</p>
    </div>
  );
}
